export enum FPTabsEnum {
    Thread = "Thread",
    Files = "Files",
    FamilyGroup = "Family Group"
}
